import './social_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.YoutubeVideoContentView extends Monitoring.Views.SocialContents.SocialContentView
